import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

export interface IURILocationKeys {
  longitude: number,
  latitude: number,
  title: string,
}

export interface IURILocation {
  place?: IURILocationKeys,
  updateURI: (uri: string) => void
}

const parseLocationHash = (value: string) => {
  const string = decodeURI(value).replace('#', '');
  const [latitude, longitude, location] = string.trim().split(/\d,/);
  const coords = (!!latitude && !!longitude && !!location)
    ? { longitude: Number(longitude), latitude: Number(latitude), title: location }
    : undefined;

  return coords;
};

export const useURILocation = (predefined: {
  lat: number,
  lng: number,
  place: string
} | null): IURILocation => {
  const router = useRouter();
  const [parsedKeys, setKeys] = useState<IURILocationKeys | undefined>(predefined ? {
    longitude: predefined?.lng,
    latitude: predefined?.lat,
    title: predefined?.place,
  } : undefined);
  const hash = global.location?.hash;
  const updateURI = useCallback((uri: string, shallow: boolean = true) => {
    const path = uri ? `?${uri}` : '';
    if (shallow) {
      window.history.pushState(undefined, document.title, `${router.pathname}${path}`);
    } else {
      router.push(`${router.pathname}${path}`, undefined, { shallow });
    }
  }, []);

  useEffect(() => {
    if (hash) {
      const keys = parseLocationHash(hash);
      setKeys(keys);
      if (keys?.title) {
        updateURI(`lat=${keys?.latitude}&lng=${keys?.longitude}&place=${encodeURIComponent(keys?.title ?? '')}`, false);
      }
    }
  }, [hash, updateURI]);

  return { place: parsedKeys, updateURI };
};
